//#region imports
import { Component, OnInit, OnDestroy } from '@angular/core';
import { Subscription } from 'rxjs';
import { ActivatedRoute } from '@angular/router';
import { Location } from '@angular/common';
import { CharacteristicService } from 'src/app/services/characteristic.service';
import { Globals } from 'src/app/services/globals';
import { GuaranteeService } from 'src/app/services/guarantee.service';
import { GuaranteeComponentModel } from 'src/app/module/guarantee/model/tarif.model';
import { DetailsComponentModel } from 'src/app/module/details/details.model';
import { DetailsService } from 'src/app/services/details.service';
import {
  CharacteristicsComponentModel,
  CharacteristicsQuestionsSelected
} from 'src/app/module/characteristics/components/characteristics.model';
import { AppConstants } from 'src/app/app.constants';
import { SummaryService } from 'src/app/services/summary.service';
import { SignatureComponentModel, Signature4Answers } from 'src/app/module/signature/model/signature.model';
import { SignatureService } from 'src/app/services/signature.service';
import { SaveAddressModel } from './../../../module/signature/model/signature.model';
import { RecapitulatoryComponentModel, SimulationReservationReason } from 'src/app/module/recapitulatory/model/recapitulatory.model';
import { P5xService } from 'src/app/services/p5x.service';
import { DocumentService } from 'src/app/services/document.service';
import { SaveService } from 'src/app/services/save.service';
import { SectionService } from 'src/app/services/section.service';
import { TranslateService } from '@ngx-translate/core';
import { MatDialog, MatDialogConfig } from '@angular/material';
import { ServerFailErrorComponent } from '../server-fail-error/server-fail-error.component';
//#endregion

@Component({
  selector: 'app-next',
  templateUrl: './next.component.html',
  styleUrls: ['./next.component.css']
})
export class NextComponent implements OnInit, OnDestroy {
  //#region variables
  language;
  clientId;
  simulationTokenValue;
  private pricingSubscription: Subscription;
  private nextDataApiSubscription: Subscription;
  characteristicChoiceSelected: boolean;
  characteristicsQuestionsSelectedListStr: string;
  characteristicsQuestionsSelectedListJSON: CharacteristicsQuestionsSelected[];
  section3 = false;
  detailsSection1or4or7or10 = false;
  subscription: Subscription;
  data;
  questionGroups;
  nextQuestionId;
  questionGroupId;
  flag = false;
  selectedValue: string;
  selectedText: any;
  selectedData: number;
  localStorageData: any;
  questions: any;
  answers: any;
  choices = [];
  groupOrder: number;
  mandatory = false;
  sectionKey: string;
  mandatoryData: any;
  answerData: any;
  detailsSection: string;

  batientSum = 0;
  ensuringContent = 0;
  capitalContentValue = 0;
  legalProtection = 0;
  flight = 0;
  deductibleReimbursement = 0;
  indirectLosses = 0;
  discontinuanceOfAppeal = 0;
  batientSumStr;
  ensuringContentStr;
  legalProtectionStr;
  flightStr;
  deductibleReimbursementStr;
  indirectLossesStr;
  discontinuanceOfAppealStr;
  capitalContentValueStr;
  tarifData: any;
  characteristicsComponent: CharacteristicsComponentModel = {
    Question1: true,
    Question2: false,
    Question3: false,
    Question4: false,
    Question5: false
  };
  detailsComponent: DetailsComponentModel;
  guaranteeComponent: GuaranteeComponentModel;
  recapitulatoryComponent: RecapitulatoryComponentModel;
  signatureComponent: SignatureComponentModel;
  saveAddress: SaveAddressModel;
  userStatus: any;
  signatureData: any;
  //#endregion

  //#region methods
  constructor(
    private characteristicService: CharacteristicService, private activatedRoute: ActivatedRoute,
    private global: Globals, private location: Location,
    private guaranteeService: GuaranteeService, private detailsService: DetailsService,
    private summaryService: SummaryService, private signatureService: SignatureService,
    private p5xService: P5xService, private saveService: SaveService,
    private translate: TranslateService, private matDialog: MatDialog,
    private documentService: DocumentService, private sectionService: SectionService) { }

  ngOnInit() {
    this.activatedRoute.queryParams.subscribe((params) => {
      this.clientId = params.clientId ? params.clientId : null;
      this.simulationTokenValue = params.simulationToken ? params.simulationToken : null;
      this.language = params.language ? params.language : AppConstants.Languages.DefaultLanguage;
    });
    this.subscription = this.characteristicService.getData().subscribe(x => {
      this.data = x;
    });
    this.characteristicService.getCharacteristicsQuestionsSelectedListStr().subscribe((value) => {
      this.characteristicsQuestionsSelectedListStr = value;
    });
    this.characteristicService.getCharacteristicChoiceSelected().subscribe((value) => {
      this.characteristicChoiceSelected = value;
    });
  }

  onNextClick() {
    let sectionURl;
    const url = this.location.path();
    this.questionGroups = null;
    this.questions = null;
    this.answers = null;
    this.choices = [];
    this.flag = false;
    this.mandatory = false;
    this.sectionKey = null;
    const index = url.indexOf('?');
    if (index !== -1) {
      sectionURl = url.substr(0, index);
    } else {
      sectionURl = url;
    }
    switch (sectionURl) {
      case '':
        this.characteristicsPreviousQuestionStore();
        this.section1Display();
        break;
      case '/characteristics':
        this.characteristicsPreviousQuestionStore();
        this.section1Display();
        break;
      case '/details':
        this.detailsSection = this.detailsService.getDetailsSection();
        if (this.detailsSection === 'S2.1') {
          this.section2Point1Display();
        } else {
          this.section2Point2Display();
        }
        break;
      case '/guarantee':
        this.section3Display();
        break;
      case '/signature':
        this.section5Display();
        break;
    }
  }

  characteristicsPreviousQuestionStore() {
    if (this.characteristicsQuestionsSelectedListStr) {
      sessionStorage.setItem(AppConstants.LocalStorage.CharacteristicQuestionsSelectedList, this.characteristicsQuestionsSelectedListStr);
      this.characteristicsQuestionsSelectedListJSON = JSON.parse(this.characteristicsQuestionsSelectedListStr);
      const length = this.characteristicsQuestionsSelectedListJSON.length;
      if (this.characteristicChoiceSelected) {
        this.characteristicService.
          setCharacteristicPreviousQuestionId(this.characteristicsQuestionsSelectedListJSON[length - 1].questionId);
      } else {
        this.characteristicService.
          setCharacteristicPreviousQuestionId(this.characteristicsQuestionsSelectedListJSON[length - 1].previousQuestionId);
      }
    }
  }

  nextSection() {
    const intialResponse = sessionStorage.getItem('jsonData');
    const initialJSONResponse = JSON.parse(intialResponse);
    if (this.sectionKey === 'S1') {
      const isTakerOther = this.p5xService.getIsTakerOther();
      const isPropertyOther = this.p5xService.getIsPropertyOther();
      if (isPropertyOther) {
        this.sectionService.setCurrentPage('P1-3');
        const simulationReservationReason: SimulationReservationReason = {
          ID: AppConstants.SimulationReservationReason.OtherProperty.ID,
          Text: AppConstants.SimulationReservationReason.OtherProperty.Text
        };
        this.saveService.setSimulationStatus('Simulation Reserved');
        this.navigateToP5X(simulationReservationReason);
      } else if (isTakerOther) {
        this.sectionService.setCurrentPage('P1-1');
        const simulationReservationReason: SimulationReservationReason = {
          ID: AppConstants.SimulationReservationReason.OtherTaker.ID,
          Text: AppConstants.SimulationReservationReason.OtherTaker.Text
        };
        this.saveService.setSimulationStatus('Simulation Reserved');
        this.navigateToP5X(simulationReservationReason);
      } else {
        this.section2Redirect(initialJSONResponse);
      }
    } else if (this.sectionKey === 'S2.1' || this.sectionKey === 'S2.2') {
      if (!this.guaranteeService.getInitialPricingData()) {
        const p215AcceptanceCriteriaChecked = this.p5xService.getP215AcceptanceCriteria();
        const p215GridCriteriaChecked = this.p5xService.getP215GridCriteriaChecked();
        const p223IndoorPoolChecked = this.p5xService.getP223IndoorPoolChecked();
        const p225AcceptanceCriteriaChecked = this.p5xService.getP225AcceptanceCriteria();
        const p225GridCriteriaChecked = this.p5xService.getP225GridCriteriaChecked();
        if (p215AcceptanceCriteriaChecked || p225AcceptanceCriteriaChecked) {
          if (this.sectionKey === 'S2.1'){
          this.sectionService.setCurrentPage('P21-5'); } else { this.sectionService.setCurrentPage('P22-5'); }
          const simulationReservationReason: SimulationReservationReason = {
            ID: AppConstants.SimulationReservationReason.AcceptanceCriteria.ID,
            Text: AppConstants.SimulationReservationReason.AcceptanceCriteria.Text
          };
          this.saveService.setSimulationStatus('Simulation Reserved');
          this.navigateToP5X(simulationReservationReason);
        } else if (p215GridCriteriaChecked || p225GridCriteriaChecked || p223IndoorPoolChecked) {
          if (p215GridCriteriaChecked){
            this.sectionService.setCurrentPage('P21-5'); } 
          else if (p225GridCriteriaChecked) { this.sectionService.setCurrentPage('P22-5'); } 
          else if (p223IndoorPoolChecked){ this.sectionService.setCurrentPage('P22-3'); }
          const simulationReservationReason: SimulationReservationReason = {
            ID: AppConstants.SimulationReservationReason.GridCriteria.ID,
            Text: AppConstants.SimulationReservationReason.GridCriteria.Text
          };
          this.saveService.setSimulationStatus('Simulation Reserved');
          this.navigateToP5X(simulationReservationReason);
        } else {
          this.section3Redirect(initialJSONResponse);
        }
      } else {
        this.guaranteeService.setGuaranteeCurrentPage(true, false, false, false, false);
        if(this.global.isMobile)
        {this.guaranteeService.setmobileGuaranteeProgressBarDetails();}
        this.sectionService.navigate('guarantee', this.clientId, this.simulationTokenValue, this.language);
      }
    }
  }

  navigateToP5X(simulationReservationReason: SimulationReservationReason) {
    this.p5xService.setSimulationReservationReason(simulationReservationReason);
    const recapitulatoryComponent: RecapitulatoryComponentModel = {
      RecapitulatoryQuestion1: false, RecapitulatoryQuestion2: true
    };
    this.summaryService.setRecapitulatoryComponent(recapitulatoryComponent);
    this.p5xService.setIsP5XPage(true);
    this.p5xService.setP5XProgressBarDetails();
    if(this.global.isMobile)
    {this.p5xService.setmobileP5XProgressBarDetails();}
    this.sectionService.navigate('recapitulatory', this.clientId, this.simulationTokenValue, this.language);
  }

  section1Display() {
    this.characteristicService.getCharacteristicsComponent().subscribe((value) => {
      this.characteristicsComponent = value;
    });
    if (this.characteristicsComponent) {
      if (this.characteristicsComponent.Question1) {
        this.sectionKey = 'S1';
        this.setData('G1', 'S1');
        this.characteristicService.setCharacteristicGroupKey('G1');
        if (this.mandatory) {
          return this.global.quesWarning = true;
        }
      } else if (this.characteristicsComponent.Question2) {
        this.sectionKey = 'S1';
        this.setData('G2', 'S1');
        this.characteristicService.setCharacteristicGroupKey('G2');
        if (this.mandatory) {
          return this.global.quesWarning = true;
        }
      } else if (this.characteristicsComponent.Question3) {
        this.sectionKey = 'S1';
        this.setData('G3', 'S1');
        this.characteristicService.setCharacteristicGroupKey('G3');
        if (this.mandatory) {
          return this.global.quesWarning = true;
        }
      } else if (this.characteristicsComponent.Question4) {
        this.sectionKey = 'S1';
        this.setData('G4', 'S1');
        this.characteristicService.setCharacteristicGroupKey('G4');
        if (this.mandatory) {
          return this.global.quesWarning = true;
        }
      } else if (this.characteristicsComponent.Question5) {
        this.sectionKey = 'S1';
        this.setData('G5', 'S1');
        this.characteristicService.setCharacteristicGroupKey('G5');
        if (this.mandatory) {
          return this.global.quesWarning = true;
        }
      }
    }

    if (this.sectionKey === 'S1') {
      switch (this.groupOrder) {
        case 2:
          this.characteristicService.setShowPrevious(true);
          this.characteristicsComponent = {
            Question1: false, Question2: true, Question3: false, Question4: false, Question5: false
          };
          this.characteristicService.setCharacteristicsComponent(this.characteristicsComponent);
          break;
        case 3:
          this.characteristicService.setShowPrevious(true);
          this.characteristicsComponent = {
            Question1: false, Question2: false, Question3: true, Question4: false, Question5: false
          };
          this.characteristicService.setCharacteristicsComponent(this.characteristicsComponent);
          break;
        case 4:
          this.characteristicService.setShowPrevious(true);
          this.characteristicsComponent = {
            Question1: false, Question2: false, Question3: false, Question4: true, Question5: false
          };
          this.characteristicService.setCharacteristicsComponent(this.characteristicsComponent);
          break;
        case 5:
          this.characteristicService.setShowPrevious(true);
          this.characteristicsComponent = {
            Question1: false, Question2: false, Question3: false, Question4: false, Question5: true
          };
          this.characteristicService.setCharacteristicsComponent(this.characteristicsComponent);
          break;
        case null:
          this.nextSection();
          break;
      }
    }
  }

  section2Redirect(initialJSONResponse) {
    const selectedDetail = initialJSONResponse.Sections[0].
      QuestionGroup.find(obj => obj.GroupKey === 'G3').Questions.find(obj => obj.QuestionKey === 'Property_Type_Question').Answers;
    if (selectedDetail !== 'undefined' && selectedDetail != null && selectedDetail.length != null
      && selectedDetail.length > 0) {
      const answerKey = selectedDetail[0].Answerkey;
      switch (answerKey) {
        case 'Property_Type_House':
          const sections1 = initialJSONResponse.Sections.find(obj => obj.SectionKey === 'S2.1');
          if (sections1 === 'undefined' || sections1 == null) {
            const poppedResponse = initialJSONResponse;
            if (initialJSONResponse.Sections.length > 1) {
              poppedResponse.Sections.pop();
            }
            initialJSONResponse = initialJSONResponse.Sections.length === 1 ? initialJSONResponse : poppedResponse;
            this.getLocationsAndCountries();
            this.documentService.setHouseOrApartmentNatureFlooring(false);
            this.callApi(initialJSONResponse);
          } else {
            this.detailsService.setDetailsComponent(null);
            this.detailsService.setDetailsSectionFromGuarantee(false);
            this.section2Point1Display();
            if(this.global.isMobile)
            {this.detailsService.setmobileDetailsProgressBarDetails();}
            this.sectionService.navigate('details', this.clientId, this.simulationTokenValue, this.language);
          }
          break;
        case 'Property_Type_Apartement':
          const sections2 = initialJSONResponse.Sections.find(obj => obj.SectionKey === 'S2.2');
          if (sections2 === 'undefined' || sections2 == null) {
            const poppedResponse = initialJSONResponse;
            if (initialJSONResponse.Sections.length > 1) {
              poppedResponse.Sections.pop();
            }
            initialJSONResponse = initialJSONResponse.Sections.length === 1 ? initialJSONResponse : poppedResponse;
            this.getLocationsAndCountries();
            this.documentService.setHouseOrApartmentNatureFlooring(false);
            this.callApi(initialJSONResponse);
          } else {
            this.detailsService.setDetailsComponent(null);
            this.detailsService.setDetailsSectionFromGuarantee(false);
            this.section2Point2Display();
            if(this.global.isMobile)
            {this.detailsService.setmobileDetailsProgressBarDetails();}
            this.sectionService.navigate('details', this.clientId, this.simulationTokenValue, this.language);
          }
          break;
      }
    }
  }

  getLocationsAndCountries() {
    this.getPostalLocation();
    this.getCountry();
    this.getMinPremium();
    this.signatureService.getData().subscribe((data) => {
      this.signatureData = data;
      // console.log(JSON.stringify(this.signatureData));
      sessionStorage.setItem('signatureData', JSON.stringify(this.signatureData));
    });
  }

  getMinPremium() {
    const minpre = this.guaranteeService.getMinimumPremium();
    if (minpre === null || minpre === undefined ){
    this.guaranteeService.getMinPremiumFromAPI().subscribe((response) => {
      this.guaranteeService.setMinimumPremium(response);
    });
    }
  }

  section2Point1Display() {
    this.sectionKey = 'S2.1';
    this.detailsService.getDetailsComponent().subscribe((value) => {
      this.detailsComponent = value;
    });
    if (!this.detailsComponent) {
      this.detailsService.setDetailsCurrentPage(true, false, false, false, false, false,
        false, false, false, false, false, false);
        if(this.global.isMobile)
        {this.detailsService.setmobileDetailsProgressBarDetails();}
      this.sectionService.navigate('details', this.clientId, this.simulationTokenValue, this.language);
    } else {
      if (this.detailsComponent.DetailsQuestion1) {
        this.setData('G6', this.sectionKey);
        if (this.mandatory) {
          return this.global.quesWarning = true;
        }
        this.detailsService.setDisableDetailsNext(false);
        this.detailsService.setDetailsCurrentPage(false, true, false, false, false, false,
          false, false, false, false, false, false);
      } else if (this.detailsComponent.DetailsQuestion2) {
        this.setData('G7', this.sectionKey);
        if (this.mandatory) {
          return this.global.quesWarning = true;
        }
        this.detailsService.setDisableDetailsNext(false);
        this.detailsService.setDetailsCurrentPage(false, false, true, false, false, false,
          false, false, false, false, false, false);
      } else if (this.detailsComponent.DetailsQuestion3) {
        this.setData('G8', this.sectionKey);
        if (this.mandatory) {
          return this.global.quesWarning = true;
        }
        this.detailsService.setDisableDetailsNext(false);
        this.detailsService.setDetailsCurrentPage(false, false, false, true, false, false,
          false, false, false, false, false, false);
      } else if (this.detailsComponent.DetailsQuestion4) {
        this.detailsSection1or4or7or10 = true;
        this.setData('G9', this.sectionKey);
        this.detailsSection1or4or7or10 = false;
        if (this.mandatory) {
          return this.global.quesWarning = true;
        }
        this.detailsService.setDisableDetailsNext(false);
        this.detailsService.setDetailsCurrentPage(false, false, false, false, true, false,
          false, false, false, false, false, false);
      } else if (this.detailsComponent.DetailsQuestion5) {
        this.setData('G10', this.sectionKey);
        if (this.mandatory) {
          return this.global.quesWarning = true;
        }
        this.detailsService.setDisableDetailsNext(true);
        this.detailsService.setDetailsCurrentPage(false, false, false, false, false, true,
          false, false, false, false, false, false);
      } else if (this.detailsComponent.DetailsQuestion6) {
        this.setData('G11', this.sectionKey);
        if(this.mandatory)
        {
          this.detailsService.setvalidateDetailsNext(true);
          return this.global.quesWarning = true;
        }
        this.guaranteeService.setGuaranteeFromRecapitulatory(false);
        this.nextSection();
      }
    }
  }

  section2Point2Display() {
    this.sectionKey = 'S2.2';
    this.detailsService.getDetailsComponent().subscribe((value) => {
      this.detailsComponent = value;
    });
    if (!this.detailsComponent) {
      this.detailsService.setDisableDetailsNext(false);
      this.detailsService.setDetailsCurrentPage(false, false, false, false, false, false,
        true, false, false, false, false, false);
        if(this.global.isMobile)
        {this.detailsService.setmobileDetailsProgressBarDetails();}
      this.sectionService.navigate('details', this.clientId, this.simulationTokenValue, this.language);
    } else {
      if (this.detailsComponent.DetailsQuestion7) {
        this.detailsSection1or4or7or10 = true;
        this.setData('G12', this.sectionKey);
        this.detailsSection1or4or7or10 = false;
        if (this.mandatory) {
          return this.global.quesWarning = true;
        }
        this.detailsService.setDisableDetailsNext(false);
        this.detailsService.setDetailsCurrentPage(false, false, false, false, false, false,
          false, true, false, false, false, false);
      } else if (this.detailsComponent.DetailsQuestion8) {
        this.setData('G13', this.sectionKey);
        if (this.mandatory) {
          return this.global.quesWarning = true;
        }
        this.detailsService.setDisableDetailsNext(false);
        this.detailsService.setDetailsCurrentPage(false, false, false, false, false, false,
          false, false, true, false, false, false);
      } else if (this.detailsComponent.DetailsQuestion9) {
        this.setData('G14', this.sectionKey);
        if (this.mandatory) {
          return this.global.quesWarning = true;
        }
        this.detailsService.setDisableDetailsNext(false);
        this.detailsService.setDetailsCurrentPage(false, false, false, false, false, false,
          false, false, false, true, false, false);
      } else if (this.detailsComponent.DetailsQuestion10) {
        this.detailsSection1or4or7or10 = true;
        this.setData('G15', this.sectionKey);
        this.detailsSection1or4or7or10 = false;
        if (this.mandatory) {
          return this.global.quesWarning = true;
        }
        this.detailsService.setDisableDetailsNext(false);
        this.detailsService.setDetailsCurrentPage(false, false, false, false, false, false,
          false, false, false, false, true, false);
      } else if (this.detailsComponent.DetailsQuestion11) {
        this.setData('G16', this.sectionKey);
        if (this.mandatory) {
          return this.global.quesWarning = true;
        }
        this.detailsService.setDisableDetailsNext(true);
        this.detailsService.setDetailsCurrentPage(false, false, false, false, false, false,
          false, false, false, false, false, true);
      } else if (this.detailsComponent.DetailsQuestion12) {
          this.setData('G17', this.sectionKey);
          if (this.mandatory) {
              this.detailsService.setvalidateDetailsNext(true);
              return this.global.quesWarning = true;
          }
        this.guaranteeService.setGuaranteeFromRecapitulatory(false);
        this.nextSection();
      }
    }
  }

  getPostalLocation() {
    this.detailsService.getLocation().subscribe((data) => {
      this.global.locationData = data;
    });
  }

  getCountry() {
    this.detailsService.getCountry().subscribe((data) => {
      this.global.countryData = data;
    });
  }

  section3Redirect(initialJSONResponse) {
    this.guaranteeService.setTarifRequest(initialJSONResponse);
    if (!this.guaranteeService.getInitialPricingData()) {      
    // const input1 = {
    //   title: this.translate.instant('Msg_Info_Title'), 
    //   errorMessage: this.translate.instant('Msg_2minutes_Delay'),
    //   disableClose: false};      
    // const dialogConfig = new MatDialogConfig();
    // dialogConfig.disableClose = true;
    // dialogConfig.data = input1; 
    // const dialogRef = this.matDialog.open(ServerFailErrorComponent, dialogConfig);
    // dialogRef.afterClosed().subscribe((confirmed: boolean) => {
      this.global.showLoaderText = true;
      this.global.showprojectText = false;
      this.global.isContentFirsttime = false;
      this.section3Display_message(initialJSONResponse); 
      // });
    } else {
      this.guaranteeService.setGuaranteeCurrentPage(true, false, false, false, false);
      if(this.global.isMobile)
      {this.guaranteeService.setmobileGuaranteeProgressBarDetails();}
      this.sectionService.navigate('guarantee', this.clientId, this.simulationTokenValue, this.language);
    }
  }
section3Display_message(initialJSONResponse){
  initialJSONResponse.CapitalUpdate = false;
      this.guaranteeService.setUpdatedPricingData(null);
      this.pricingSubscription = this.guaranteeService.getTarificationEvaluationApi(initialJSONResponse).subscribe(
        (response) => {
          this.sectionService.setCurrentPage('P3-1');
          const contactDetails = this.saveService.getContactDetails();
          const saveRequest = {
            firstName: contactDetails.FirstName, lastName: contactDetails.LastName,
            email: contactDetails.EmailAddress, phone: contactDetails.Telephone, code: contactDetails.PostalCode
          };
          this.p5xService.setContentCapital(false);
          this.guaranteeService.setCalculatedPremiumAfterUpdatingCapital(true);
          const maxCapitalBuilding = +this.guaranteeService.getMaximumCapitalBatiment();
          const capitalBuilding = +((response.Evaluation.CapitalBatimentEvalue).replace(',', '.'));
          if (capitalBuilding > maxCapitalBuilding) {
            const simulationReservationReason: SimulationReservationReason = {
              ID: AppConstants.SimulationReservationReason.BuildingCapital.ID,
              Text: AppConstants.SimulationReservationReason.BuildingCapital.Text
            };
            this.p5xService.setSimulationReservationReason(simulationReservationReason);
            if (this.detailsService.getDetailsSection() === 'S2.1') {
              this.p5xService.setP216CapitalGreaterThanMax(true);
              this.p5xService.setP226CapitalGreaterThanMax(false);
              this.sectionService.setCurrentPage('P21-6');
            } else {
              this.p5xService.setP216CapitalGreaterThanMax(false);
              this.p5xService.setP226CapitalGreaterThanMax(true);
              this.sectionService.setCurrentPage('P22-6');
            }
            // this.guaranteeService.setContentCovering(true);
            // this.guaranteeService.setTarificationValues(response);
            this.global.sendSimulationMail = false;
            this.saveService.saveSimulation(saveRequest, 'Save').subscribe((data) => {
              this.saveService.setSimulationToken(data.Tocken);
              this.saveService.setProspectNumber(data.CRMProspect);
              this.saveService.setShortToken(data.shortTocken);
              this.saveService.setSimulationStatus('Simulation Reserved');
              this.navigateToP5X(simulationReservationReason);
            });
          } else {
            this.guaranteeService.setContentCovering(true);
            this.guaranteeService.setTarificationValues(response);
            this.guaranteeService.setCalculatedPremiumAfterUpdatingCapital(true);
            this.guaranteeService.setExecuteTarification(false);
            this.guaranteeService.setUpdateEnsuringContentCheck(false);
            this.guaranteeService.setBtnCalculateClickedChk(false);
            this.global.sendSimulationMail = false;
            this.saveService.saveSimulation(saveRequest, 'Save').subscribe((data) => {
              this.saveService.setSimulationToken(data.Tocken);
              this.saveService.setProspectNumber(data.CRMProspect);
              this.saveService.setShortToken(data.shortTocken);
              this.guaranteeService.setGuaranteeProgressBarDetails();
              this.section3Display();
            });
          }
          this.global.showLoaderText = false;
        }, (error) => {
          const input = {
            title: this.translate.instant('Msg_Error_Title'), 
            errorMessage: this.translate.instant('Msg_Service_Error'),
            disableClose: false};
          this.characteristicService.serverFailError(input);
        });
}
  section3Display() {
    this.guaranteeService.setExecuteTarification(true);
    this.guaranteeService.getGuaranteeComponent().subscribe((value) => {
      this.guaranteeComponent = value;
    });
    if (!this.guaranteeComponent) {
      this.guaranteeService.setGuaranteeCurrentPage(true, false, false, false, false);
      if(this.global.isMobile)
      {this.guaranteeService.setmobileGuaranteeProgressBarDetails();}
      this.sectionService.navigate('guarantee', this.clientId, this.simulationTokenValue, this.language);
    } else {
      if (this.guaranteeComponent.GuaranteeQuestion1) {
        const propertyDestinationRenting = this.guaranteeService.getPropertyDestinationRenting();
        if (propertyDestinationRenting) {
          this.guaranteeService.setGuaranteeCurrentPage(false, false, true, false, false);
        } else {
          this.guaranteeService.setGuaranteeCurrentPage(false, true, false, false, false);
          this.guaranteeService.setIsPreviousP31Point1(true);
        }
      } else if (this.guaranteeComponent.GuaranteeQuestion2) {
        if (this.guaranteeService.getCalculatedPremiumAfterUpdatingCapital()) {
          this.guaranteeService.setGuaranteeCurrentPage(false, false, true, false, false);
          this.guaranteeService.setIsPreviousP31Point1(false);
        } else {
          this.global.calculateError = true;
          return this.global.calculateError;
        }
      } else if (this.guaranteeComponent.GuaranteeQuestion3) {
        const propertyDestinationRenting = this.guaranteeService.getPropertyDestinationRenting();
        const contentCovering = this.guaranteeService.getContentCovering();
        const propTypeHouse = this.documentService.getIsHouse();
        const secondaryResidence = this.guaranteeService.getResidencePrinciple();
        const isOwner = this.p5xService.getIsOwner();
        if (propertyDestinationRenting) {
          this.guaranteeService.setGuaranteeCurrentPage(false, false, false, false, true);
        } else {
          if (contentCovering) {
            // if(propertyDestinationRenting === false && isOwner === true && propTypeHouse === true && secondaryResidence === 'false' ){
            //   this.guaranteeService.setGuaranteeCurrentPage(false, false, false, false, true);
            // }
            // else
            // {
            this.guaranteeService.setGuaranteeCurrentPage(false, false, false, true, false);
            // }
          } else {
            this.guaranteeService.setGuaranteeCurrentPage(false, false, false, false, true);
          }
        }
      } else if (this.guaranteeComponent.GuaranteeQuestion4) {
        if (this.global.isTheftZero){
          this.recapitulatoryComponent = {
            RecapitulatoryQuestion1: false, RecapitulatoryQuestion2: true
          };
          this.summaryService.setRecapitulatoryComponent(this.recapitulatoryComponent);
          this.sectionService.setCurrentPage('P3-4');
          const simulationReservationReason: SimulationReservationReason = {
            ID: AppConstants.SimulationReservationReason.SecondHomeContent.ID,
            Text: AppConstants.SimulationReservationReason.SecondHomeContent.Text
          };
          this.p5xService.setP5XProgressBarDetails();
          this.saveService.setSimulationStatus('Simulation Reserved');
          this.navigateToP5X(simulationReservationReason);
        }
        else{this.guaranteeService.setGuaranteeCurrentPage(false, false, false, false, true);}
      } else if (this.guaranteeComponent.GuaranteeQuestion5) {
        const isOwner = this.p5xService.getIsOwner();
        const isSecondaryResidence = this.p5xService.getSecondaryResidence();
        const isTheft = this.p5xService.getTheftChecked();
        const minPrem = this.guaranteeService.getMinimumPremium();
        const totprem = this.global.totalPremium.replace(',', '.');
        if (this.p5xService.getContentCapital()) {
          this.recapitulatoryComponent = {
            RecapitulatoryQuestion1: false, RecapitulatoryQuestion2: true
          };
          this.summaryService.setRecapitulatoryComponent(this.recapitulatoryComponent);
          this.sectionService.setCurrentPage('P3-2');
          const simulationReservationReason: SimulationReservationReason = {
            ID: AppConstants.SimulationReservationReason.ContentCapital.ID,
            Text: AppConstants.SimulationReservationReason.ContentCapital.Text
          };
          this.p5xService.setP5XProgressBarDetails();
          this.saveService.setSimulationStatus('Simulation Reserved');
          this.navigateToP5X(simulationReservationReason);

        } else if (isOwner && isSecondaryResidence && isTheft) {
          this.recapitulatoryComponent = {
            RecapitulatoryQuestion1: false, RecapitulatoryQuestion2: true
          };
          this.summaryService.setRecapitulatoryComponent(this.recapitulatoryComponent);
          this.sectionService.setCurrentPage('P3-4');
          const simulationReservationReason: SimulationReservationReason = {
            ID: AppConstants.SimulationReservationReason.SecondHomeContent.ID,
            Text: AppConstants.SimulationReservationReason.SecondHomeContent.Text
          };
          this.p5xService.setP5XProgressBarDetails();
          this.saveService.setSimulationStatus('Simulation Reserved');
          this.navigateToP5X(simulationReservationReason);
        } else if (Number(totprem) < Number(minPrem)) {
          this.recapitulatoryComponent = {
            RecapitulatoryQuestion1: false, RecapitulatoryQuestion2: true
          };
          this.summaryService.setRecapitulatoryComponent(this.recapitulatoryComponent);
          this.sectionService.setCurrentPage('P3-4');
          const simulationReservationReason: SimulationReservationReason = {
            ID: AppConstants.SimulationReservationReason.MinimumPremium.ID,
            Text: AppConstants.SimulationReservationReason.MinimumPremium.Text
          };
          this.p5xService.setP5XProgressBarDetails();
          this.saveService.setSimulationStatus('Simulation Reserved');
          this.navigateToP5X(simulationReservationReason);
        } else {
          this.sectionService.setCurrentPage('P4-1');
          const contactDetails = this.saveService.getContactDetails();
          const saveRequest = {
            firstName: contactDetails.FirstName, lastName: contactDetails.LastName,
            email: contactDetails.EmailAddress, phone: contactDetails.Telephone, code: contactDetails.PostalCode
          };
          this.global.sendSimulationMail = false;
          // commenting this part as part of US1158 as this will be uncommented later.
		      this.saveService.saveSimulation(saveRequest, 'sendSave').subscribe((data) => { 
              this.saveService.setSimulationToken(data.Tocken);
              this.saveService.setProspectNumber(data.CRMProspect);
              this.saveService.setShortToken(data.shortTocken);
            });
          this.recapitulatoryComponent = {
            RecapitulatoryQuestion1: true, RecapitulatoryQuestion2: false
          };
          this.summaryService.setRecapitulatoryComponent(this.recapitulatoryComponent);
          this.summaryService.setSummaryProgressBarDetails();
        }
        if(this.global.isMobile)
        {this.summaryService.setmobileSummaryProgressBarDetails();}
        this.sectionService.navigate('recapitulatory', this.clientId, this.simulationTokenValue, this.language);
      }
    }
  }

  section5Display() {
    this.signatureService.getSignatureComponent().subscribe((value) => {
      this.signatureComponent = value;
    });
    if (this.signatureComponent.SignatureQuestion1) {
      this.validateSignature();
    } else if (this.signatureComponent.SignatureQuestion2) {
      this.validateSignature();
    } else if (this.signatureComponent.SignatureQuestion3) {
      this.validateSignature();
    } else if (this.signatureComponent.SignatureQuestion4) {
      if (this.signatureService.getAcceptanceCriteria()) {
        const simulationReservationReason: SimulationReservationReason = {
          ID: AppConstants.SimulationReservationReason.AcceptanceCriteria.ID,
          Text: AppConstants.SimulationReservationReason.AcceptanceCriteria.Text
        };
        // this.p5xService.setDisableP5XPrevious(true);
        this.saveService.setSimulationStatus('Simulation Reserved');
        this.navigateToP5X(simulationReservationReason);
      } else if (this.signatureService.getP5XTxtBoxRequirement()) {
        const simulationReservationReason: SimulationReservationReason = {
          ID: AppConstants.SimulationReservationReason.SpecificRequest.ID,
          Text: AppConstants.SimulationReservationReason.SpecificRequest.Text
        };
        // this.p5xService.setDisableP5XPrevious(true);
        this.saveService.setSimulationStatus('Simulation Reserved');
        this.navigateToP5X(simulationReservationReason);
      } else if (this.p5xService.getRSRStatus()) {
        const simulationReservationReason: SimulationReservationReason = {
          ID: AppConstants.SimulationReservationReason.RSR.ID,
          Text: AppConstants.SimulationReservationReason.RSR.Text
        };
        this.p5xService.setSimulationReservationReason(simulationReservationReason);
        this.recapitulatoryComponent = {
          RecapitulatoryQuestion1: false, RecapitulatoryQuestion2: true
        };
        this.summaryService.setRecapitulatoryComponent(this.recapitulatoryComponent);
        this.p5xService.setP5XProgressBarDetails();
        this.p5xService.setDisableP5XPrevious(true);
        if(this.global.isMobile)
        {this.p5xService.setmobileP5XProgressBarDetails();}
        this.sectionService.navigate('recapitulatory', this.clientId, this.simulationTokenValue, this.language);
      }
       else {
        this.signatureService.setShowSignaturePrevious(false);
        this.signatureService.setShowSignatureNext(true);
        this.signatureService.setSignatureCurrentPage(false, false, false, false, true, false, false, false);
        // const input1 = {
        //   title: this.translate.instant('Msg_Info_Title'), 
        //   errorMessage: this.translate.instant('Msg_2minutes_Delay'),
        //   disableClose: false};
        // const dialogConfig = new MatDialogConfig();
        // dialogConfig.disableClose = true;
        // dialogConfig.data = input1; 
        // const dialogRef = this.matDialog.open(ServerFailErrorComponent, dialogConfig);
        // dialogRef.afterClosed().subscribe((confirmed: boolean) => {
            // this.documentService.callDocumentumFromSignature(this.clientId, this.simulationTokenValue, this.language);
        // });
      }
    } else if (this.signatureComponent.SignatureQuestion5) {
      const contactDetails = this.saveService.getContactDetails();
      this.documentService.callDocumentumFromSignature(this.clientId, this.simulationTokenValue, this.language);
      // const saveRequest = {
      //       firstName: contactDetails.FirstName, lastName: contactDetails.LastName,
      //       email: contactDetails.EmailAddress, phone: contactDetails.Telephone, code: contactDetails.PostalCode
      //     };
      // this.saveService.setIsProjectCompleted(true);
      // this.saveService.setProjectStatus('Project Completed');
      // this.saveService.saveSimulation(saveRequest, 'Save').subscribe((data) => {
      //       this.saveService.setSimulationToken(data.Tocken);
      //       this.saveService.setProspectNumber(data.CRMProspect);
      //       this.saveService.setShortToken(data.shortTocken);
      //       this.signatureService.setShowSignaturePrevious(true);
      //       this.signatureService.setShowSignatureNext(true);
      //       this.signatureService.setSignatureCurrentPage(false, false, false, false, false, true, false);
      //   });
    } else if (this.signatureComponent.SignatureQuestion6) {
      this.signatureService.saveSignedDocument().subscribe((value) => {
        if (value) {
          const contactDetails = this.saveService.getContactDetails();
          const saveRequest = {
            firstName: contactDetails.FirstName, lastName: contactDetails.LastName,
            email: contactDetails.EmailAddress, phone: contactDetails.Telephone, code: contactDetails.PostalCode
          };
          this.saveService.setIsProjectCompleted(true);
          this.saveService.setProjectStatus('Project Signed');
          this.global.sendSimulationMail = false;
          this.saveService.saveSimulation(saveRequest, 'Save').subscribe((data) => {
            this.saveService.setSimulationToken(data.Tocken);
            this.saveService.setProspectNumber(data.CRMProspect);
            this.saveService.setShortToken(data.shortTocken);
            this.signatureService.setShowSignaturePrevious(false);
            this.signatureService.setShowSignatureNext(false);
            this.signatureService.setSignatureCurrentPage(false, false, false, false, false, false, true, false);
          });
        }
      }, (error) => {
        const input = {
          title: this.translate.instant('Msg_Error_Title'), 
          errorMessage: this.translate.instant('Msg_Service_Error'), 
          disableClose: false};
        this.characteristicService.serverFailError(input);
      });
    }
  }

  validateSignature() {
    const signatureData = JSON.parse(sessionStorage.getItem('signatureData'));
    this.signatureService.getSaveAddress().subscribe((value) => {
      this.saveAddress = value;
    });
    this.signatureService.getSignatureComponent().subscribe((value) => {
      this.signatureComponent = value;
    });
    if (this.signatureComponent.SignatureQuestion1) {
      if (signatureData.Premium_Frequency_paiement != null) {
        this.signatureService.setShowSignaturePrevious(true);
        this.signatureService.setSignatureCurrentPage(false, true, false, false, false, false, false, false);
        this.global.quesWarning = false;
        return;
      } else {
        this.signatureService.setShowSignaturePrevious(false);
        this.signatureService.setSignatureCurrentPage(true, false, false, false, false, false, false, false);
        this.global.quesWarning = true;
        return;
      }
    }
    if (this.signatureComponent.SignatureQuestion2) {
      if (signatureData.Property_Address_Street !== '' && signatureData.Property_Address_Street_Number !== ''
      && signatureData.Property_Address_Street !== null && signatureData.Property_Address_Street_Number !== null) {
        this.signatureService.setShowSignaturePrevious(true);
        this.signatureService.setShowSignatureNext(true);
        this.signatureService.setSignatureCurrentPage(false, false, true, false, false, false, false, false);
        this.global.quesWarning = false;
        return;
      } else {
        this.signatureService.setShowSignaturePrevious(true);
        this.signatureService.setSignatureCurrentPage(false, true, false, false, false, false, false, false);
        this.global.quesWarning = true;
        return;
      }
    }
    if (this.signatureComponent.SignatureQuestion3) {
      if (signatureData.Taker_Name !== '' && signatureData.Taker_Last_Name !== ''
        && signatureData.Simulation_mail_Contact !== '' && signatureData.Simulation_Phone_Contact !== ''
        && signatureData.Taker_Civility !== '' && signatureData.Taker_BirthDate !== ''
        && signatureData.Taker_Address_Post_Code !== '' && signatureData.Taker_Address_Place !== '' && signatureData.Taker_Address_Place !== null
        && signatureData.Taker_Address_Street !== '' && signatureData.Taker_Address_Street_Number !== '' && this.signatureService.signaturepage3validate == true) {
        this.signatureService.checkUserStatus().subscribe((data) => {
          this.userStatus = data.ListerRSRResult.RSR;
          if (this.userStatus == null){this.sectionService.setCurrentPage('P5-4');}
          else{this.sectionService.setCurrentPage('P5-3');}
          
          const contactDetails = this.saveService.getContactDetails();
          const saveRequest = {
            firstName: contactDetails.FirstName, lastName: contactDetails.LastName,
            email: contactDetails.EmailAddress, phone: contactDetails.Telephone, code: contactDetails.PostalCode
          };
          this.global.sendSimulationMail = false;
          this.saveService.saveSimulation(saveRequest, 'Save').subscribe((saveResponse) => {
            this.saveService.setSimulationToken(saveResponse.Tocken);
            this.saveService.setProspectNumber(saveResponse.CRMProspect);
            this.saveService.setShortToken(saveResponse.shortTocken);
            if (this.userStatus == null) {
              this.p5xService.setRSRStatus(false);
              const signature4Answers: Signature4Answers = {
                FirstCheckbox: false, SecondCheckbox: false, ThirdCheckbox: false,
                FourthCheckbox: false, RequirementText: ''
              };
              this.signatureService.setSignature4Answers(signature4Answers);
              this.signatureService.setShowSignaturePrevious(true);
              this.signatureService.setShowSignatureNext(true);
              this.signatureService.setSignatureCurrentPage(false, false, false, true, false, false, false, false);
              this.global.quesWarning = false;
              return;
            } else {
              this.p5xService.setRSRStatus(true);
              const signature4Answers: Signature4Answers = {
                FirstCheckbox: false, SecondCheckbox: false, ThirdCheckbox: false,
                FourthCheckbox: false, RequirementText: ''
              };
              this.signatureService.setSignature4Answers(signature4Answers);
              this.signatureService.setShowSignaturePrevious(true);
              this.signatureService.setShowSignatureNext(true);
              this.signatureService.setSignatureCurrentPage(false, false, false, true, false, false, false, false);
              this.global.quesWarning = false;
              return;
              // const simulationReservationReason: SimulationReservationReason = {
              //   ID: AppConstants.SimulationReservationReason.RSR.ID,
              //   Text: AppConstants.SimulationReservationReason.RSR.Text
              // };
              // this.p5xService.setSimulationReservationReason(simulationReservationReason);
              // this.recapitulatoryComponent = {
              //   RecapitulatoryQuestion1: false, RecapitulatoryQuestion2: true
              // };
              // this.summaryService.setRecapitulatoryComponent(this.recapitulatoryComponent);
              // this.p5xService.setP5XProgressBarDetails();
              // this.p5xService.setDisableP5XPrevious(true);
              // if(this.global.isMobile)
              // {this.p5xService.setmobileP5XProgressBarDetails();}
              // this.sectionService.navigate('recapitulatory', this.clientId, this.simulationTokenValue, this.language);
            }
          });
        });
      } else {
        this.signatureService.setShowSignaturePrevious(true);
        this.signatureService.setShowSignatureNext(true);
        this.signatureService.setSignatureCurrentPage(false, false, true, false, false, false, false, false);
        this.global.quesWarning = true;
      }
    }
  }

  callApi(initialJSONResponse) {
    this.nextDataApiSubscription = this.characteristicService.getNextDataApi(initialJSONResponse).subscribe((response) => {
      initialJSONResponse.Sections.push(response[0]);
      sessionStorage.setItem('jsonData', JSON.stringify(initialJSONResponse));
      const sectionKey = response[0].SectionKey;
      if (sectionKey === 'S2.1') {
        this.detailsService.setDetailsProgressBarDetails();
        this.detailsService.setDetailsSection('S2.1');
        this.detailsComponent = {
          DetailsQuestion1: true, DetailsQuestion2: false, DetailsQuestion3: false,
          DetailsQuestion4: false, DetailsQuestion5: false, DetailsQuestion6: false,
          DetailsQuestion7: false, DetailsQuestion8: false, DetailsQuestion9: false,
          DetailsQuestion10: false, DetailsQuestion11: false, DetailsQuestion12: false
        };
        this.detailsService.setDetailsComponent(this.detailsComponent);
        this.detailsService.setDetailsSectionFromGuarantee(false);
        this.global.detailsHeader = 'GH2';
        if(this.global.isMobile)
        {this.detailsService.setmobileDetailsProgressBarDetails();}
        this.sectionService.navigate('details', this.clientId, this.simulationTokenValue, this.language);
      } else if (sectionKey === 'S2.2') {
        this.detailsService.setDetailsProgressBarDetails();
        this.detailsService.setDetailsSection('S2.2');
        this.detailsComponent = {
          DetailsQuestion1: false, DetailsQuestion2: false, DetailsQuestion3: false,
          DetailsQuestion4: false, DetailsQuestion5: false, DetailsQuestion6: false,
          DetailsQuestion7: true, DetailsQuestion8: false, DetailsQuestion9: false,
          DetailsQuestion10: false, DetailsQuestion11: false, DetailsQuestion12: false
        };
        this.detailsService.setDetailsComponent(this.detailsComponent);
        this.detailsService.setDetailsSectionFromGuarantee(false);
        this.global.detailsHeader = 'GH3';
        if(this.global.isMobile)
        {this.detailsService.setmobileDetailsProgressBarDetails();}
        this.sectionService.navigate('details', this.clientId, this.simulationTokenValue, this.language);
      }
    });
  }

  setData(groupKey, sectionKey) {
    this.localStorageData = sessionStorage.getItem('jsonData');
    const jsonData = JSON.parse(this.localStorageData);
    this.data = jsonData;
    this.questionGroups = jsonData.Sections.find(obj => obj.SectionKey === sectionKey).
      QuestionGroup;
    this.questions = this.questionGroups.find(obj => obj.GroupKey === groupKey).Questions[0];
    const questionChoices = this.questionGroups.find(obj => obj.GroupKey === groupKey).Questions[0].QuestionChoices;
    this.answers = this.questionGroups.find(obj => obj.GroupKey === groupKey).Questions[0].Answers;

    this.questionGroups.find(obj => obj.GroupKey === groupKey).Questions.
      forEach(obj => {
        // mandatory:obj.Mandatory;Answers:obj.Answers
        this.selectedData = (obj.Answers !== 'undefined'
          && obj.Answers != null
          && obj.Answers.length != null
          && obj.Answers.length > 0) ? obj.Answers[0].ChoiceId : 0;
        if ((this.selectedData === 0) && (!this.mandatoryData)) {
          this.mandatory = this.questions.Mandatory;
        } else {
          return;
        }
      });

    if (questionChoices.find(obj => obj.ChoiceKey != null) != null) {
      for (const choice in questionChoices) {
        this.choices.push(questionChoices[choice]);
      }

      for (const ch of this.choices) {
        if (ch.ChoiceId === Number(this.selectedData)) {
          this.nextQuestionId = ch.NextQuestionId;
          break;
        } else {
          this.nextQuestionId = ch.NextQuestionId;
        }
      }
      if (this.nextQuestionId > 0) {
        for (const questionGroup of this.questionGroups) {
          const questions = questionGroup.Questions;
          for (const obj1 of questions) {
            if (obj1.QuestionId === this.nextQuestionId) {
              this.groupOrder = questionGroup.GroupOrder;
              this.flag = true;
            }
          }
          if (this.flag === true) {
            break;
          }
        }
      } else {
        this.groupOrder = null;
      }
    } else if (this.detailsSection1or4or7or10) {
      this.groupOrder = this.questionGroups[this.questionGroups.findIndex(obj => obj.GroupKey === groupKey) + 1].GroupOrder;
    } else {
      this.groupOrder = null;
    }
  }

  ngOnDestroy() {
    if (this.pricingSubscription) {
      this.pricingSubscription.unsubscribe();
    }
    if (this.nextDataApiSubscription) {
      this.nextDataApiSubscription.unsubscribe();
    }
  }
  //#endregion
}
